<template>
  <div>

    <template v-if="disabled">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on">
            <v-btn color="secondary" x-small disabled><v-icon small>edit</v-icon></v-btn>
          </div>
        </template>
        <span v-html="tooltipText"></span>
      </v-tooltip>
    </template>

    <template v-else>
      <v-btn color="secondary" x-small @click="$emit('clicked')"><v-icon small>edit</v-icon></v-btn>
    </template>

  </div>
</template>

<script>
  export default {

    props: {

      disabled: {
        type: Boolean,
        default: true
      },

      tooltipText: {
        type: String,
        default: ''
      }

    },

  }
</script>

<style lang="scss" scoped>

</style>
